import Box from 'carbon-react/esm/components/box';
import Button from 'carbon-react/esm/components/button/__next__';
import Typography from 'carbon-react/esm/components/typography';
import Portrait from 'carbon-react/esm/components/portrait';
import Divider from 'carbon-react/lib/components/divider';
import { Dl, Dt, Dd } from 'carbon-react/esm/components/definition-list';
import { User } from '@auth0/auth0-react';
import { useResponsive } from '../../../hooks/useResponsive';
import { ENV } from '../../../config/env';

const UserInfosTab = ({ user }: User) => {
  const { isMobile } = useResponsive();

  return (
    <Box bg="white" p={isMobile ? '16px' : '23px'} height="calc(100% - 64px)">
      <Typography variant="h2" mb={isMobile ? 12 : 16}>
        Paramètres
      </Typography>
      <Box
        marginLeft="auto"
        marginRight="auto"
        display="flex"
        maxWidth={900}
        alignItems={isMobile ? 'center' : 'flex-start'}
        flexDirection={isMobile ? 'column' : 'row'}
        borderRadius="borderRadius000"
        // gap="var(--spacing800)"
        gap={isMobile ? 'var(--spacing150)' : 'var(--spacing800)'}
      >
        <Box
          display="flex"
          maxWidth="640px"
          flexDirection="column"
          alignItems="center"
          border-radius="var(--borderRadius000)"
        >
          <Box display="flex" alignItems="baseline">
            <Portrait key="portrait" size={isMobile ? 'L' : 'XXL'} src={user.picture} />
          </Box>
        </Box>
        <Box maxWidth="640px" border-radius="var(--borderRadius000)">
          <Typography variant="h3" mb={24}>
            Informations personnelles
          </Typography>
          <Typography variant="p">
            Modifiez les informations de votre compte, l&apos;adresse e-mail, le mot de passe et les
            paramètres d&apos;authentification à 2 facteurs.
          </Typography>
          <Dl w={200} dtTextAlign="left" asSingleColumn>
            <Dt>Prénom</Dt>
            <Dd>{user.given_name}</Dd>
            <Dt>Nom</Dt>
            <Dd>{user.family_name}</Dd>
            <Dt>E-mail</Dt>
            <Dd>{user.email}</Dd>
          </Dl>
          <Button
            href={ENV.CLOUDID_ACCOUNT_URL}
            target="_blank"
            rel="noopener noreferrer"
            variantType="primary"
            iconType="edit"
            iconPosition="after"
            size="medium"
            mt={16}
            paddingLeft={30}
            paddingRight={30}
          >
            Modifier les données du compte
          </Button>
          <Divider type="horizontal" mt={7} mb={7} />
        </Box>
      </Box>
    </Box>
  );
};

export default UserInfosTab;
